import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { EmpDetails, Header } from "@aptsi-types";
import { IdentityProvisioningService } from "../identity-provisioning.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";

@Component({
  selector: "app-assign-digital-id",
  templateUrl: "./assign-digital-id.component.html",
  styleUrls: ["./assign-digital-id.component.scss"],
})
export class AssignDigitalIdComponent {
  totalPages = 0;
  totalPagesNormal = 0;
  totalPagesSearch = 0;

  itemsPerPage =7;
  currentPage = 1 ;


  get paginatedData() {
    
      if(!this.issearch){
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredData.slice(start, end);
      }
      else{
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        
        return this.searchedData.slice(start, end);
      }
      
    
  }
  
  filteredData: EmpDetails[] = []; 
  searchedData: EmpDetails[] = []; 


  buttonConfig = {
     update: false,
     delete: false,
     import: false,
     configure: false
  };

  changePage(page: number) {
    this.currentPage = page;
    if (!this.issearch) {
      this.totalPages = this.totalPagesNormal;  // Ensure correct total pages
      this.fetchempDetails();
    } else {
      this.totalPages = this.totalPagesSearch;  // Ensure correct total pages
      this.fetchempDetailsSearch();
    }
  }

  headers: Header[] = [
    {
      name: "Employee Id",
      property: "id",
      showInDropdown: true,
      description: "Unique identifier assigned to the employee", // Tooltip content
    },
    {
      name: "Name",
      property: "displayName",
      showInDropdown: true,
      description: "Full name of the employee",
    },
    {
      name: "Email",
      property: "mail",
      showInDropdown: false,
      description: "Email address of the employee",
    },
    {
      name: "Date of Birth",
      property: "date_of_birth",
      showInDropdown: false,
      description: "Employee's date of birth",
    },
    {
      name: "Organization",
      property: "organization",
      showInDropdown: true,
      description: "Organization the employee belongs to",
    },
    {
      name: "Organizational Unit",
      property: "organizational_unit",
      showInDropdown: true,
      description: "Specific unit or department of the organization",
    },
    {
      name: "Organization Id",
      property: "organizationId",
      showInDropdown: true,
      description: "Unique identifier for the organization",
    },
    {
      name: "Start Date",
      property: "startDate",
      showInDropdown: false,
      description: "Date when the employee started working",
    },
  ];
  
  searchText: string = null;
  filterByHeader: string = "all";
  filterName: string = null;
  empDetails: EmpDetails[] = [];
  nullver: number = 1;
  issearch: boolean = false;

  constructor(
    private router: Router,
    private identityProvisioningService: IdentityProvisioningService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    // const dropdownHeaders = this.headers.filter(
    //   header => header.showInDropdown
    // );

    // if (dropdownHeaders.length > 1) {
    //   this.filterByHeader = dropdownHeaders[1].property;
    // }

    this.fetchempDetails();
    this.cdr.detectChanges(); 
  }

  async fetchempDetails() {
    try {
      const response = await this.identityProvisioningService
        .getEmpDetailViewForAssign(this.currentPage - 1)
        .toPromise();
      // this.empDetails = response["Resource fetched successfully."] || [];
      this.filteredData = [...response];
  
      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesNormal = response[0].totalPages;
        this.totalPages = this.totalPagesNormal;  // Sync `totalPages` with `totalPagesNormal`
        this.currentPage = response[0].currentPage + 1;
      }
      //this.empDetails.sort((a, b) => a.id - b.id);
    } catch (error) {
      console.error("Error fetching assets :", error);
    }
  }

  async fetchempDetailsSearch() {
    try {
      const response = await this.identityProvisioningService.getEmpDetailViewForAssignSearch(this.currentPage - 1, this.searchText, this.filterByHeader).toPromise();
      this.searchedData = [...response];
  
      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearch = response[0].totalPages;
        this.totalPages = this.totalPagesSearch;  // Sync `totalPages` with `totalPagesSearch`
        this.currentPage = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  }

     async searchempDetails(): Promise<void> {
    try {
      if (this.searchText) {

        // Default value
        if (!this.filterByHeader) {
          this.filterByHeader = "all";
        }

        this.issearch = true;

        await this.fetchempDetailsSearch();
        this.totalPages = this.totalPagesSearch;

        const selectedHeader = this.headers.find(
          (h) => h.property === this.filterByHeader && h.showInDropdown
        );

        if (this.filterByHeader === "all") {

          this.searchedData = this.searchedData.filter((rule) =>
            this.headers.some((header) => {
              const value = rule[header.property];

              return value
                ?.toString()
                .toLowerCase()
                .includes(this.searchText.toLowerCase());
            })
          );

        } else if (selectedHeader) {

          this.searchedData = this.searchedData.filter((rule) => {
            const value = rule[selectedHeader.property];

            return value
              ?.toString()
              .toLowerCase()
              .includes(this.searchText.toLowerCase());
          });

          this.searchedData.sort((a, b) =>
            a[selectedHeader.property]
              ?.toString()
              .localeCompare(b[selectedHeader.property]?.toString())
          );

        } else {
          this.filteredData = [];
        }

      } else {

        this.issearch = false;
        await this.fetchempDetails();

      }
    } catch (error) {
      console.error("Error during search:", error);
    }
  }

  back() {
    try {
      if (this.issearch) {
        this.issearch = false;
        this.totalPages = this.totalPagesNormal;  // Restore total pages for normal pagination
        this.currentPage = 1;
        this.fetchempDetails(); 
      } else {
        this.router.navigate(['digital-identity/auth-tools/identity-provisioning']);
      }
     } catch (error) {
        console.error("Error fetching Assets:", error);
     }
  }

  async assign() {
    const response = await this.identityProvisioningService
      .AssignDigitalId(this.nullver)
      .toPromise();
    this.openSuccessDialog();
  }

  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: {
        isMessage: true,
        isCreateUpdate: false,
        title: "Digital Id Assigned Successfully",
        subTitle:
          "Digital ID has been successfully assigned. The asset is now uniquely identified and ready for use.",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate([
        "digital-identity/auth-tools/identity-provisioning",
      ]);
    });
  }
}
